<a
  class="app-envelope"
  nz-dropdown
  nzPlacement="bottomRight"
  nzTrigger="click"
  [nzDropdownMenu]="envelopeDropdown"
  [nzClickHide]="false"
  (nzVisibleChange)="changeDropdownVisible($event)"
  [(nzVisible)]="dropdownVisible"
  data-cy="messages-envelope"
>
  <nz-badge [nzCount]="(messageCount$ | async)?.unread">
    <app-image name="messages"></app-image>
  </nz-badge>
</a>

<nz-dropdown-menu #envelopeDropdown="nzDropdownMenu">
  <ul class="app-envelope-dropdown" nz-menu [nzMode]="'inline'">
    <li class="app-envelope-dropdown-title">
      <app-image name="messages-menu"></app-image>
      <span translate>envelope.dropdown.title</span>
    </li>
    <nz-divider></nz-divider>
    @if (unreadMessageThreads$ | async; as unreadMessageThreads) { @if (unreadMessageThreads.length > 0) {
    <li class="app-envelope-dropdown-messages">
      <app-message-thread-list
        [messageThreads]="unreadMessageThreads$ | async"
        [size]="'small'"
        (messageSelected)="selectMessageThread($event)"
      ></app-message-thread-list>
    </li>
    } @else {
    <app-empty-inbox class="app-envelope-dropdown-no-messages" [textCode]="'envelope.dropdown.empty'"></app-empty-inbox>
    } } @if ((messageCount$ | async)?.total > 0) {
    <li class="app-envelope-dropdown-see-all">
      <a (click)="seeAll()" translate>envelope.dropdown.all</a>
    </li>
    }
    <nz-divider></nz-divider>
    <li class="app-envelope-dropdown-new-message">
      <a data-cy="messages-new-link" (click)="startMessageThread()" translate>envelope.dropdown.new</a>
    </li>
  </ul>
</nz-dropdown-menu>
